<template>
  <div v-if="user" class="container">
    <el-row>
      <el-col :span="11">
        <HomeInfoCard />
      </el-col>
      <el-col :span="11" :offset="1">
        <CreditStatusCard />
      </el-col>
    </el-row>
  </div>
  <div v-else>

  </div>
</template>

<script>
import { mapState } from "vuex"
import { AUTHENTICATE_STORE } from "@/store/modules/AuthenticateStore.js"
import FAIcon from "@/components/common/FAIcon.vue"
import HomeInfoCard from "@/components/HomeComponents/HomeInfoCard.vue"
import CreditStatusCard from "@/components/HomeComponents/CreditStatusCard.vue"
import HomeQuickActions from "@/components/HomeComponents/HomeQuickActions.vue"
import DocumentStatistic from "@/components/HomeComponents/DocumentStatistic.vue"
import RecentCreditUsage from "@/components/HomeComponents/RecentCreditUsage.vue"
import {Paths} from '@/routes/paths.js'

export default {
  name: "Home",
  components: { RecentCreditUsage, DocumentStatistic, HomeQuickActions, CreditStatusCard, HomeInfoCard, FAIcon },
  computed: mapState({
    user: (state) => state[AUTHENTICATE_STORE].user,
  }),
  watch: {
    user: (newUser, ) => {
      if (!newUser || !newUser.id){
        this.$router.push(Paths.LOGIN)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
a {
  color: steelblue;
}
</style>
